import { render, staticRenderFns } from "./user-list1.vue?vue&type=template&id=a4b9edfe&scoped=true&"
import script from "./user-list1.vue?vue&type=script&lang=js&"
export * from "./user-list1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b9edfe",
  null
  
)

export default component.exports